import { uniqBy } from 'lodash'
import { CarModel, CarStatus, Region, Subdivision } from '~/shared/api'
import {
  carAtWorkSubStatusEnumOptions,
  carPropertyTypeEnumOptions,
  carUnderRepairSubStatusEnumOptions,
  fuelTypeEnumOptions,
} from '~/shared/config/constants'
import { Filter } from '~/shared/ui/AsyncGrid'

export const filters: Filter[] = [
  {
    field: 'vin',
    label: 'filter.vin',
    type: 'text',
  },
  {
    field: 'plateNumber',
    label: 'filter.license plate number',
    type: 'text',
  },
  {
    field: 'regionId',
    label: 'filter.region',
    type: 'autocompleteMultiple',
    fetchOptions: Region.fetchOptions,
  },
  {
    field: 'subdivisionId',
    label: 'filter.subdivision',
    type: 'autocompleteMultiple',
    fetchOptions: Subdivision.fetchOptions,
  },
  {
    field: 'status',
    label: 'filter.status',
    type: 'autocompleteMultiple',
    fetchOptions: CarStatus.fetchOptions,
    canAsyncSearch: false,
  },
  {
    field: 'subStatus',
    label: 'filter.substatus',
    type: 'selectMultiple',
    options: uniqBy(
      [...carUnderRepairSubStatusEnumOptions, ...carAtWorkSubStatusEnumOptions],
      'id',
    ),
  },
  {
    field: 'carModelId',
    label: 'filter.model',
    type: 'autocomplete',
    fetchOptions: CarModel.fetchOptions,
  },
  {
    field: 'fuelType',
    label: 'filter.fuel type',
    type: 'selectMultiple',
    options: fuelTypeEnumOptions,
  },
  {
    field: 'propertyType',
    label: 'filter.type of ownership',
    type: 'select',
    options: carPropertyTypeEnumOptions,
  },
  {
    field: 'isLeasingFullyPaid',
    label: 'filter.buyout',
    type: 'boolean',
  },
  {
    field: 'isPromotion',
    label: 'filter.participates in promotion',
    type: 'boolean',
  },
  {
    field: 'isPreTotaled',
    label: 'filter.pre total',
    type: 'boolean',
  },
]
